export default `
  /*!
   * Ladda
   * http://lab.hakim.se/ladda
   * MIT licensed
   *
   * Copyright (C) 2016 Hakim El Hattab, http://hakim.se
   */

  /*************************************
   * CONFIG
   */

  $spinnerSize: 32px;

  /*************************************
   * BUTTON BASE
   */

  .ladda-button {
    position: relative;
  }

  /* Spinner animation */
  .ladda-button .ladda-spinner {
    position: absolute;
    z-index: 2;
    display: inline-block;
    width: $spinnerSize;
    top: 50%;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
  }

  /* Button label */
  .ladda-button .ladda-label {
    position: relative;
    z-index: 3;
  }

  /*************************************
   * EASING
   */

  .ladda-button,
  .ladda-button .ladda-spinner,
  .ladda-button .ladda-label {
    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
  }

  .ladda-button[data-style="zoom-in"],
  .ladda-button[data-style="zoom-in"] .ladda-spinner,
  .ladda-button[data-style="zoom-in"] .ladda-label,
  .ladda-button[data-style="zoom-out"],
  .ladda-button[data-style="zoom-out"] .ladda-spinner,
  .ladda-button[data-style="zoom-out"] .ladda-label {
    transition: 0.3s ease all;
  }

  /*************************************
   * ZOOM-OUT
   */

  .ladda-button[data-style="zoom-out"] {
    overflow: hidden;
  }
  .ladda-button[data-style="zoom-out"] .ladda-spinner {
    left: 50%;
    margin-left: $spinnerSize;

    transform: scale(2.5);
  }
  .ladda-button[data-style="zoom-out"] .ladda-label {
    position: relative;
    display: inline-block;
  }

  .ladda-button[data-style="zoom-out"][data-loading] .ladda-label {
    opacity: 0;

    transform: scale(0.5);
  }
  .ladda-button[data-style="zoom-out"][data-loading] .ladda-spinner {
    opacity: 1;
    margin-left: 0;

    transform: none;
  }

  /*************************************
   * ZOOM-IN
   */

  .ladda-button[data-style="zoom-in"] {
    overflow: hidden;
  }
  .ladda-button[data-style="zoom-in"] .ladda-spinner {
    left: 50%;
    margin-left: $spinnerSize/-2;

    transform: scale(0.2);
  }
  .ladda-button[data-style="zoom-in"] .ladda-label {
    position: relative;
    display: inline-block;
  }

  .ladda-button[data-style="zoom-in"][data-loading] .ladda-label {
    opacity: 0;

    transform: scale(2.2);
  }
  .ladda-button[data-style="zoom-in"][data-loading] .ladda-spinner {
    opacity: 1;
    margin-left: 0;

    transform: none;
  }
`;
